// Generated by scripts/build-dist.ts: each runtime Python file's
// content-hashed URL in dist/.
export const RUNTIME_PYTHON_URLS = Object.freeze({
  "extra_drivers/quansheng/f4hwn_v4_3.py": "./python/extra_drivers/quansheng/f4hwn_v4_3.024ff9d263.py",
  "extra_drivers/quansheng/f4hwn_v5_9_0.py": "./python/extra_drivers/quansheng/f4hwn_v5_9_0.09d23891a6.py",
  "extra_drivers/quansheng/f4hwn_v6.py": "./python/extra_drivers/quansheng/f4hwn_v6.c1c560ae08.py",
  "extra_drivers/quansheng/f4hwn_v6_1_0.py": "./python/extra_drivers/quansheng/f4hwn_v6_1_0.ccbf2ec24c.py",
  "runtime_bridge.py": "./python/runtime_bridge.73bb743711.py",
  "webchirp_bridge/__init__.py": "./python/webchirp_bridge/__init__.b59d80eee1.py",
  "webchirp_bridge/channel_extra.py": "./python/webchirp_bridge/channel_extra.994f7e5b24.py",
  "webchirp_bridge/channel_rows.py": "./python/webchirp_bridge/channel_rows.ea38fb1623.py",
  "webchirp_bridge/chirp_loader.py": "./python/webchirp_bridge/chirp_loader.92a2a54623.py",
  "webchirp_bridge/clone.py": "./python/webchirp_bridge/clone.13d013932a.py",
  "webchirp_bridge/column_metadata.py": "./python/webchirp_bridge/column_metadata.290664ae82.py",
  "webchirp_bridge/images.py": "./python/webchirp_bridge/images.dba5984c09.py",
  "webchirp_bridge/jsbridge.py": "./python/webchirp_bridge/jsbridge.c8b91f95d7.py",
  "webchirp_bridge/power_levels.py": "./python/webchirp_bridge/power_levels.7a4bf3521a.py",
  "webchirp_bridge/radio_files.py": "./python/webchirp_bridge/radio_files.fb7775e07c.py",
  "webchirp_bridge/radio_memories.py": "./python/webchirp_bridge/radio_memories.b9ef28056b.py",
  "webchirp_bridge/radio_settings.py": "./python/webchirp_bridge/radio_settings.e94b9df077.py",
  "webchirp_bridge/row_normalization.py": "./python/webchirp_bridge/row_normalization.1155b75f22.py",
  "webchirp_bridge/row_validation.py": "./python/webchirp_bridge/row_validation.1d81b23927.py",
  "webchirp_bridge/rpc.py": "./python/webchirp_bridge/rpc.593d827056.py",
  "webchirp_bridge/runtime_errors.py": "./python/webchirp_bridge/runtime_errors.f641f6b9c5.py",
  "webchirp_bridge/serial_pipe.py": "./python/webchirp_bridge/serial_pipe.f9884fba42.py",
  "webchirp_bridge/session.py": "./python/webchirp_bridge/session.179c0df3da.py"
});
